import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Textbox } from '../../models/editors/textbox.model';
import { Textarea } from '../../models/editors/textarea.model';
import { Switch } from '../../models/editors/switch.model';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { FormControlService } from '../../shared/services/form-control.service';
import { ApiService } from '../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../shared/services/alert.service';
import { Category } from '../../models/categories/categories.model';
import { FormDetailBase } from '../../shared/components/base/form-detail/form-detail.base.component';
@Component({
  selector: 'swb-category-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService],
  encapsulation: ViewEncapsulation.None
})
export class CategoryDetailComponent extends FormDetailBase<Category> implements OnInit {

  public url = 'categories';
  protected _redirect = './articles';

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název kategorie',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'description',
        label: 'Úvodní text',
        validators: [],
        isMultilang: true,
        wysiwyg: 'news-detail'
      }),
      new Switch({
        key: 'custom_seo_data',
        label: 'Vlastní metadata',
        isMultilang: true,
        labelFalse: 'Vygenerovaná metadata'
      }),
      new Textbox({
        key: 'seo_title',
        label: 'Titulek',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Textarea({
        key: 'seo_description',
        label: 'Popisek',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_seo_data'
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }
    this._getEntity();
  }

}
